export default __webpack_public_path__ + "static/multi-light-ca0838be37f7fe07bb8ac2e73170a593.png";